import React from "react";

import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import axios from '../../axios/axiosconf';
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Loading from "../general/Loading";

function Estadisticas() {

    const [loggedIn, setLoggedIn] = useState(false);
    const [client, setClient] = useState([]);

    useEffect(() => {

        if (!localStorage.getItem('userdata')) {
            setLoggedIn(true);
            return;
        }

        const userdata = JSON.parse(localStorage.getItem('userdata'));

        axios.get('/get-client', {
            headers: { Authorization: 'Bearer ' + userdata.access_token }
        })
            .then(response => {
                if (response.status === 200) {
                    setClient(response.data);
                }
                setLoggedIn(true);
            })
            .catch(() => {
                setLoggedIn(true);
            });
    }, []);

    if (loggedIn) {
        return (
            <div className="wrapper hold-transition" style={{ fontSize: '13px' }}>
                <Header client={client} />
                <Aside client={client} activelink="reports" />

                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-12">
                                    <ol className="breadcrumb float-sm-left mb-0">
                                        <li className="breadcrumb-item"><Link to="/home">Home</Link></li>
                                        <li className="breadcrumb-item active">Reportes</li>
                                    </ol>
                                </div>
                            </div>
                            <div className="row mb-2 align-items-end">
                                <div className="col-md-8">
                                    <div className="dash-wrap">
                                        <h1 className="dash-title">Reportes</h1>
                                        <p className="dash-subtitle mb-0">Agenda, pacientes y acceso a reportes contables en una ventana aparte</p>
                                    </div>
                                </div>
                                <div className="col-md-4 mt-2 mt-md-0 text-md-right">
                                    <Link to="/home" className="btn btn-outline-secondary btn-sm" style={{ borderRadius: '10px', fontWeight: 600 }}>
                                        <i className="fas fa-arrow-left mr-1"></i> Volver al inicio
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section className="content">
                        <div className="container-fluid">
                            <div className="dash-card mb-4">
                                <div className="dash-card-header">
                                    <h2 className="dash-card-title">
                                        <span className="title-icon" aria-hidden="true"><i className="fas fa-chart-bar"></i></span>
                                        Consultas
                                    </h2>
                                </div>
                                <div className="dash-card-body">
                                    <div className="quick-grid">
                                        <Link to="/reportes-agenda" className="quick-card">
                                            <div className="quick-ico"><i className="fas fa-calendar-check"></i></div>
                                            <p className="quick-title">Agenda</p>
                                            <p className="quick-sub">Estadísticas y reporte de citas</p>
                                        </Link>

                                        <Link to="/reporte-pacientes" className="quick-card">
                                            <div className="quick-ico"><i className="fas fa-user-injured"></i></div>
                                            <p className="quick-title">Pacientes</p>
                                            <p className="quick-sub">Reportes de Pacientes</p>
                                        </Link>

                                        <Link to="/estadisticas-contables" className="quick-card" style={{ textDecoration: 'none', color: 'inherit' }}>
                                            <div className="quick-ico"><i className="fas fa-calculator"></i></div>
                                            <p className="quick-title">Contables</p>
                                            <p className="quick-sub">Estado de cuenta, facturación, libro diario…</p>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
                <Footer showToast={false} delay={0} />
            </div>
        );
    }

    return (
        <Loading />
    );
}
export default Estadisticas;
